import { useContactManagementTranslation } from '../../../../ui/hooks/useContactManagementTranslation';
import { TextCell } from '@juvare/common-data-table-ui/DataTable';
import React from 'react';
export function useUserDirectoryColumns() {
    const { t } = useContactManagementTranslation();
    return React.useMemo(() => {
        const userDirectory = [
            {
                headerLabel: t('panels.accounts.columnLabels.lastName'),
                sortKey: 'lastName',
                cellFunction: (row) => React.createElement(TextCell, null, row.lastName),
            },
            {
                headerLabel: t('panels.accounts.columnLabels.firstName'),
                sortKey: 'firstName',
                cellFunction: (row) => React.createElement(TextCell, null, row.firstName),
            },
            {
                headerLabel: t('panels.userDirectory.columnLabels.contactEmails'),
                cellFunction: (row) => { var _a; return React.createElement(TextCell, null, (_a = row.contactEmails) === null || _a === void 0 ? void 0 : _a.join(', ')); },
                tableCellSx: {
                    display: {
                        xs: 'none',
                        sm: 'table-cell',
                    },
                },
            },
            {
                headerLabel: t('panels.userDirectory.columnLabels.contactPhones'),
                cellFunction: (row) => { var _a; return React.createElement(TextCell, null, (_a = row.contactPhoneNumbers) === null || _a === void 0 ? void 0 : _a.join(', ')); },
                tableCellSx: {
                    display: {
                        xs: 'none',
                        sm: 'table-cell',
                    },
                },
            },
            {
                headerLabel: t('panels.userDirectory.columnLabels.county'),
                sortKey: 'county',
                cellFunction: (row) => React.createElement(TextCell, null, row.county),
            },
        ];
        return userDirectory;
    }, [t]);
}
